import { Injectable } from "@snap/ts-inject";
import type { AnalyticsEventsHandler } from "./registerLensAnalyticEventsHandler";

/**
 * @internal
 */
export const lensAnalyticEventsHandlerFactory = Injectable("LensAnalyticEventsHandler", (): AnalyticsEventsHandler => {
    return () => {};
});
